class MCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("m-cart") || this.closest("m-cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("m-cart-remove-button", MCartRemoveButton);

class MCartTemplate extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = undefined;
    this.isCartPage = MinimogSettings.templateName === "cart";
    this.cartDrawerWrapper = document.querySelector("m-cart-drawer");
    this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner");
    this.mainCartItems = this.querySelector("[data-minimog-cart-items]");
    this.cartSubTotal = this.querySelector("[data-cart-subtotal]");
    this.cartDiscount = this.querySelector("[data-minimog-cart-discounts]");
    this.giftWrapping = this.querySelector("[data-minimog-gift-wrapping]");
    
    let loadingTarget = this.cartDrawerInner;
    if (this.isCartPage) loadingTarget = document.body;
    this.loading = new MinimogLibs.AnimateLoading(loadingTarget, { overlay: loadingTarget });

    this.rootUrl = window.Shopify.routes.root;

    // Debounce to prevent multiple rapid clicks
    const debouncedOnChange = debounce((event) => {
      if (event.target.name === "updates[]") {
        this.onChange(event);
      }
    }, 300);

    if (this.isCartPage && this.mainCartItems) {
      this.mainCartItems.addEventListener("change", debouncedOnChange.bind(this));
    } else {
      this.addEventListener("change", debouncedOnChange.bind(this));
    }

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (response) => {
      this.getCart().then((cart) => {
        this.updateCartCount(cart.items);
      });
    });
  }

  updateCartCount(cartItems) {
    let totalQty = 0;
    cartItems.forEach((item) => {
      totalQty += item.quantity; // Standard quantity only
    });

    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (totalQty > 0) {
        cartCount.textContent = totalQty > 10 ? '10+' : totalQty;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onChange(event) {
    // Standard quantity update - No decimals
    const quantity = parseInt(event.target.value);
    const index = event.target.dataset.index;
    this.updateQuantity(index, quantity);
  }

  updateQuantity(line, quantity) {
    this.loading.start();
    const { routes } = window.MinimogSettings;

    const body = JSON.stringify({
      line: parseInt(line),
      quantity: parseInt(quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.loading.finish();
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // Force UI update
        this.classList.toggle("m-cart--empty", parsedState.item_count === 0);
        if (this.cartDrawerWrapper)
          this.cartDrawerWrapper.classList.toggle("m-cart--empty", parsedState.item_count === 0);

        // Render sections to update prices
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { ...parsedState, source: "main-cart-items" });

        // VERY IMPORTANT: Refresh prices and total
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: parsedState } }));
        
        // Optional: Force reload to ensure Liquid logic updates
        // window.location.reload(); 
      })
      .catch((e) => console.error(e))
      .finally(() => {
        this.loading.finish();
      });
  }

  getSectionsToRender() {
    return [
      { id: "MinimogCart", section: "cart-template", selector: "[data-minimog-cart-items]" },
      { id: "MinimogCart", section: "cart-template", selector: "[data-cart-subtotal]" },
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-cart-items]" },
      { id: "MinimogCartDrawerFooter", section: "cart-drawer", selector: "[data-cart-subtotal]" }
    ];
  }

  getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    return parsed.querySelector(selector)?.innerHTML || "";
  }

  updateLiveRegions(line, message) {
    let lineItemNode = document.getElementById(`MinimogCartDrawer-Item-${line}`) || document.getElementById(`MinimogCart-Item-${line}`);
    if (message !== "" && lineItemNode) {
      MinimogTheme.Notification.show({ target: lineItemNode, type: "warning", message: message });
    }
  }
}
customElements.define("m-cart", MCartTemplate);